var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { BRow, BCol, BCard, BModal, BButton, ModalPlugin, BFormGroup, BFormInput, BImg, BOverlay, BAlert } from 'bootstrap-vue';
import axios from 'axios';
import { DiscountsBreakdown } from 'vallatonvue';
import { getWholesaleSheetPrice, getWholesaleUnitPrice } from 'ts/modules/pricing';
import { addToCart } from 'ts/modules/cart';
import debounce from 'lodash/debounce';
import { sheetDelivery } from 'ts/modules/delivery';
Vue.use(ModalPlugin);
let WholesaleProduct = class WholesaleProduct extends Vue {
    constructor() {
        super(...arguments);
        this.loadingDiscounts = true;
        this.loadingPrice = true;
        this.quantity = 1;
        this.discounts = [];
        this.pricing = {
            base_unit_price: '0.00',
            ex_vat_base_unit_price: '0.00',
            unit_price: '0.00',
            total_price: '0.00',
            unit_discount: '0.00',
            total_discount: '0.00'
        };
        this.delivery = {
            isValid: true,
            problems: [],
            warnings: []
        };
        this.debouncedGetPrice = debounce(this.getPrice, 350);
    }
    get isQuantityValid() {
        return this.quantity > 0;
    }
    get isAddToCartDisabled() {
        return !this.isQuantityValid;
    }
    get buyButtonVariant() {
        return this.isQuantityValid ? 'success' : 'danger';
    }
    get moreInfoLink() {
        var _a;
        return `/diy-framing/accessories/${this.type.slug}/${(_a = this.product.meta) === null || _a === void 0 ? void 0 : _a.slug}`;
    }
    get quantityLabel() {
        return this.product.sheet ? 'Number of sheets:' : 'Number of boxes:';
    }
    get modalId() {
        return `buy-modal-${this.product.id}`;
    }
    get wholesaleSku() {
        return `WS${this.product.sku}`;
    }
    get cartAttributes() {
        if (this.product.sheet) {
            return {
                "Size": `${this.product.sheet.width_mm}x${this.product.sheet.height_mm}mm`,
                "Delivery Available": this.delivery.isValid.toString()
            };
        }
        else if (this.product.unit) {
            return {
                "Box Size": this.product.unit.bulk_quantity.toString()
            };
        }
        return {};
    }
    showBuyModal() {
        this.$bvModal.show(this.modalId);
    }
    addToCart() {
        addToCart({
            sku: `WS${this.product.sku}`,
            attributes: this.cartAttributes,
            qty: this.quantity
        }, false);
    }
    getPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.product.sku || !this.isQuantityValid) {
                return;
            }
            this.loadingPrice = true;
            if (this.product.sheet) {
                this.pricing = yield getWholesaleSheetPrice(this.product.sku, this.quantity);
                this.delivery = yield sheetDelivery(this.product.sku, {
                    width: this.product.sheet.width_mm,
                    length: this.product.sheet.height_mm
                });
            }
            else {
                this.pricing = yield getWholesaleUnitPrice(this.product.sku, this.quantity);
            }
            this.loadingPrice = false;
        });
    }
    getDiscounts() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loadingDiscounts = true;
            let { data } = yield axios
                .get('/api/accessories/wholesaleDiscounts', {
                params: {
                    productID: this.product.id,
                    unitPrice: this.pricing.ex_vat_base_unit_price
                }
            });
            this.discounts = data;
            this.loadingDiscounts = false;
        });
    }
    mounted() {
        if (this.isSelected) {
            this.$bvModal.show(this.modalId);
        }
    }
};
__decorate([
    Prop(Object)
], WholesaleProduct.prototype, "product", void 0);
__decorate([
    Prop(Object)
], WholesaleProduct.prototype, "type", void 0);
__decorate([
    Prop(Boolean)
], WholesaleProduct.prototype, "isSelected", void 0);
__decorate([
    Watch('quantity')
], WholesaleProduct.prototype, "debouncedGetPrice", void 0);
__decorate([
    Watch('pricing.base_unit_price')
], WholesaleProduct.prototype, "getDiscounts", null);
WholesaleProduct = __decorate([
    Component({
        components: {
            BRow, BCol, BCard, BModal, BButton, BFormGroup, BFormInput, BImg, BOverlay, BAlert,
            DiscountsBreakdown
        }
    })
], WholesaleProduct);
export default WholesaleProduct;
